export const API = {
  GET: {
    HOME: (homeId: string) => `login/homes/${homeId}`,
    LOGIN_HOMES: "login/homes",
    PATIENTS: "patients",
    TODAY_HISTORY_BY_PATIENT_ID: (id: string) => `patients/${id}/today-history`,
    PATIENT_BY_ID: (id: string) => `patients/${id}`,
    DOCTORS: "doctors",
    GUIDES: "guides",
    ARCHIVE_PATIENTS: "patients/archive",
    PDF: (pdfUrl: string) => `/pdf?url=${pdfUrl}`,
    SPECIFIC_DRUG: (dragRegNum: string) => `medication/${dragRegNum}`,
    GET_HISTORY_BY_PATIENT: (
      patientId: string,
      startDate?: string,
      endDate?: string,
      numberOfDaysAgo?: number
    ) => {
      let url = `history/patient/${patientId}`;
      if (numberOfDaysAgo) {
        url = url.concat(`?numberOfDaysAgo=${numberOfDaysAgo}`);
      } else {
        if (startDate) {
          url = url.concat(`?startDate=${startDate}`);
        }
        if (endDate) {
          url = url.concat(`endDate=${endDate}`);
        }
      }

      return url;
    },
  },
  POST: {
    LOGOUT: "login/logout",
    REFRESH: "login/refresh-token",
    LOGIN: "login",
    ADD_HISTORY: "history",
    ADD_PATIENT: "patients",
    ADD_GUIDE: "guides",
    ADD_DOCTOR: "doctors",
    SETUP_2FA: "2fa/setup",
    VERIFY_2FA: "2fa/verify",
    PILL_AUTOCOMPLETE: "medication/autocomplete",
    FIND_DRUG_By_NAME: "medication/findDrugByName",
    GET_SPECIFIC_DRUG: "medication/getSpecificDrug",
    ARCHIVE_PATIENT: (id: string) => `patients/${id}/archive`,
    CREATE_PILL: (id: string) => `patients/${id}/add-drug`,
    RESTORE_PATIENT: (id: string) => `patients/${id}/restore`,
    SUBSCRIBE_NOTIFICATION: "subscribe",
  },
  DELETE: {
    REMOVE_AUTH_KEY: (id: string) => `2fa/${id}`,
    REMOVE_DOCTOR: (id: string) => `doctors/${id}`,
    REMOVE_ARCHIVE_PATIENT: (id: string) => `patients/${id}`,
    REMOVE_GUIDE: (id: string) => `guides/${id}`,
    REMOVE_PILL: (patientId: string, pillId: string) =>
      `patients/${patientId}/delete-drug/${pillId}`,
  },
  PUT: {
    EDIT_USER_ROLE: (id: string) => `2fa/${id}`,
    EDIT_PATIENT: (id: string) => `patients/${id}`,
    EDIT_PILL: (id: string, pillId: string) =>
      `patients/${id}/edit-pill/${pillId}`,
  },
  PATCH: {
    EDIT_DOCTOR: (id: string) => `patients/${id}/doctor`,
  },
};
